var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F5F7F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4851 20.0002L25.9723 15.5131L26.8976 14.5877C27.0341 14.4512 27.0341 14.2294 26.8976 14.0929L25.9075 13.1028C25.771 12.9663 25.5492 12.9663 25.4127 13.1028L20.0002 18.5153L14.5877 13.1024C14.4512 12.9659 14.2294 12.9659 14.0929 13.1024L13.1024 14.0925C12.9659 14.229 12.9659 14.4508 13.1024 14.5873L18.5153 20.0002L13.1024 25.4127C12.9659 25.5492 12.9659 25.771 13.1024 25.9075L14.0925 26.8976C14.229 27.0341 14.4508 27.0341 14.5873 26.8976L20.0002 21.4851L24.4874 25.9723L25.4127 26.8976C25.5492 27.0341 25.771 27.0341 25.9075 26.8976L26.8976 25.9075C27.0341 25.771 27.0341 25.5492 26.8976 25.4127L21.4851 20.0002Z",
    fill: "#335C75"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseHeader);
export default __webpack_public_path__ + "static/media/CloseHeader.e4dff30e.svg";
export { ForwardRef as ReactComponent };